import React, {useState, useEffect, Fragment, useContext} from "react";
import Layout from "components/sales/layout/layout";
import {BaseUrl} from "contexts/baseUrl/baseUrl";
import DivLayout from "../../../../../components/sales/divLayout/divLayout";
import DocumentView from "../../../../../components/sales/downloadDocView/documentView";
import Images from 'assets/images/imageData';
import {toast} from "react-toastify";
import DropDownInput from "../../../../../components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "../../../../../components/sales/Input/constantInput/constantInput";
import {Button} from "react-bootstrap";
import FormSection from "../../../../../components/sales/formSection/formSection";
import s from "../../../../../components/sales/paymentPortal/addPayment/addPayment.module.css";
import ModalPop from "../../../../../components/sales/modal/modal";

const PaymentDetails = ({
                            match,
                            history,
                            documentUploadUrlPublic,
                            documentUrlDataPublic,
                            loanAccountRequest,
                            loanAccountResponse = [],
                            loanApplicationByIdRequest,
                            loanApplicationByIdResponse = [],
                            loanTranchesRequest,
                            loanTranchesResponse = [],
                            loanPaymentRequestRequest,
                            loanPaymentRequestResponse = [],
                            updateTrancheStatusResponse = [],
                            updateTrancheStatusRequest,
                            caseStatusUpdateRequest,
                            loanApprovalRequestRequest,
                            loanApprovalRequestResponse
                        }) => {
    const {baseUrl} = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [inputList, setInputList] = useState([]);

    const [otherBankName, setBankName] = useState(true);
    const [stage, setStage] = useState(1);
    const [roleId, setRoleId] = useState('');
    const [utrNo, setUtrNo] = useState('')
    const [status, setStatus] = useState('');
    const [remark, setRemark] = useState('');
    const [changeCarLoanStatusModalOpen, setChangeCarLoanStatusModalOpen] = useState(false)
    const [userId, setUserId] = useState()

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            setRoleId(localStorage.getItem('fusion-role'))
            setUserId(JSON.parse(window.localStorage.loginDetails)?.id)
            await loanAccountRequest(match?.params?.id)
            await loanApplicationByIdRequest(match?.params?.id)
            await loanTranchesRequest(match?.params?.id)
            await loanPaymentRequestRequest(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    const handleInput = (val, index, e = '', key = '') => {
        const list = [...inputList]
        list[0][key][index] = '';
        list[0][key][index] = val
        setInputList(list)
    }


    const handleChangeStatus = async (e, trancheId, status) => {
        if (status === 'DISBURSED' && !utrNo) {
            toast.error("Utr no is missing!");
            return false;
        }
        setIsLoading(true)
        await updateTrancheStatusRequest({status: status, loan_id: match?.params?.id, tranche_id: trancheId})
        setIsLoading(false)
    }


    const handleStage = stageNo => {
        setStage(stageNo)
    }

    console.log(updateTrancheStatusResponse)
    useEffect(() => {
        if (parseInt(updateTrancheStatusResponse?.status) === 200) {
            toast.success(updateTrancheStatusResponse?.message);
            window.location.reload();
        } else if (parseInt(updateTrancheStatusResponse?.status) !== 200) {
            toast.error(updateTrancheStatusResponse?.message);
        }
    }, [updateTrancheStatusResponse]);

    const handleSubmit = async (e) => {
        e.preventDefault();
    }

    const handlePaymentApproval = async (e) => {
        if (!status) {
            toast.error("Please select status!");
            return false;
        }
        setIsLoading(true)
        await loanApprovalRequestRequest({status: status, loan_id: match?.params?.id, remark:remark})
        setIsLoading(false)
    }


    const handleChangeStatusForRelease = async (trancheId) => {
        if (status === 'DISBURSED' && !utrNo) {
            toast.error("Utr no is missing!");
            return false;
        }
        setIsLoading(true)
        await updateTrancheStatusRequest({status: status, loan_id: match?.params?.id, tranche_id: trancheId, utr_no:utrNo})
        setIsLoading(false)
    }

    useEffect(() => {
        if (parseInt(loanApprovalRequestResponse?.status) === 200) {
            toast.success(loanApprovalRequestResponse?.message);
            setChangeCarLoanStatusModalOpen(false)
            window.location.reload();
        } else if (parseInt(loanApprovalRequestResponse?.status) !== 200) {
            toast.error(loanApprovalRequestResponse?.message);
        }
    }, [loanApprovalRequestResponse]);
    const headerBtns = () => {
        return (
            <Fragment>
                <Button
                    onClick={() => {
                        setChangeCarLoanStatusModalOpen(true)
                    }}
                    className="filter-hamburger btn btn-transparent"
                >
                    {"Change Status"}
                </Button>
            </Fragment>
        );
    };

    return (
        <>
            <Layout
                title={"Payment Details"}
                isLoading={isLoading}
                isGoback={true}
                Buttons={parseInt(roleId) === 13 ? headerBtns : ""}
            >
                <div className="container-fluid">
                    <div className="container-v2">
                        <link rel="stylesheet"
                              href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.0.3/css/font-awesome.css"/>
                        <div id="msform">
                            <ul id="progressbar">
                                <li id="confirm" className={`${(stage < 2) ? 'active' : 'done'}`}><span
                                    className='pb-v2'><strong>Loan Details</strong></span></li>
                                <li id="confirm"
                                    className={`${(stage == 2) ? 'active' : (stage > 2) ? 'done' : 'inactive'}`}>
                                    <span className='pb-v2'><strong>Account Details</strong></span></li>
                                <li id="confirm"
                                    className={`${(stage == 3) ? 'active' : (stage > 3) ? 'done' : 'inactive'}`}>
                                    <span className='pb-v2'><strong>Tranches</strong></span>
                                </li>
                                <li id="confirm"
                                    className={`${(stage == 4) ? 'active' : (stage > 4) ? 'done' : 'inactive'}`}>
                                    <span className='pb-v2'><strong>Payment Request</strong></span>
                                </li>
                            </ul>


                        </div>
                    </div>
                    <form onSubmit={(e) => handleSubmit(e)}>
                        {stage === 1 &&
                            <>
                                <div className="panel-card">
                                    <div className="panel-body">
                                        <div className="details-listing">
                                            <div className="row">
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Existing Loan"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.existing_loan === true ? 'Yes' : 'No'
                                                        }
                                                    />
                                                </div>
                                                {console.log("qwed", loanApplicationByIdResponse)}
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Loan Type"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.loan_type
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Total Loan Amount"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.loan_approved_amount
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"For Closure Amount"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.fore_closure_amount
                                                        }
                                                    />
                                                </div>
                                                {loanApplicationByIdResponse?.data?.fore_closure_amount_proof &&
                                                    <div className="col-6">
                                                        <DocumentView
                                                            attachment={loanApplicationByIdResponse?.data?.fore_closure_amount_proof}
                                                            title={"For Closure Amount Proof"}
                                                        />
                                                    </div>
                                                }

                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Mode Of Payment"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.mode_of_payment
                                                        }
                                                    />
                                                </div>
                                                {loanApplicationByIdResponse?.data?.loan_closure_payment_proof &&
                                                    <div className="col-6">
                                                        <DocumentView
                                                            attachment={loanApplicationByIdResponse?.data?.loan_closure_payment_proof}
                                                            title={"Loan Closure Payment Proof"}
                                                        />
                                                    </div>
                                                }

                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Hold Back Amount"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.hold_back_amount
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DocumentView
                                                        attachment={loanApplicationByIdResponse?.data?.hold_back_amount_proof}
                                                        title={"Hold Back Amount Proof"}
                                                    />
                                                </div>
                                                {/* <div className="col-6">
                                                    <DivLayout
                                                        heading={"Loan Amount Received From Bank"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.loan_amount_received_from_bank
                                                        }
                                                    />
                                                </div> */}
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Existing Loan UTR Number"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.bank_transfer_utr_number
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"RTO Charges"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.rto_charges
                                                        }
                                                    />
                                                </div>
                                                {loanApplicationByIdResponse?.data?.documents?.rto_receipt &&
                                                    <div className="col-6">
                                                        <DocumentView
                                                            attachment={loanApplicationByIdResponse?.data?.documents?.rto_receipt}
                                                            title={"RTO Receipt"}
                                                        />
                                                    </div>
                                                }

                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Challan  Charge"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.challan_charges
                                                        }
                                                    />
                                                </div>
                                                {loanApplicationByIdResponse?.data?.documents?.challan_receipt &&
                                                    <div className="col-6">
                                                        <DocumentView
                                                            attachment={loanApplicationByIdResponse?.data?.documents?.challan_receipt}
                                                            title={"Challan Receipt"}
                                                        />
                                                    </div>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {loanApplicationByIdResponse?.data?.bank_transfer_loan_details && loanApplicationByIdResponse?.data?.bank_transfer_loan_details.length > 0 &&
                                    loanApplicationByIdResponse?.data?.bank_transfer_loan_details.map((val, i) => {
                                        return (
                                            <>
                                                <div className="panel-card">
                                                    <div className="panel-heading">
                                                        Bank Transfer Loan Details {i+1}
                                                    </div>
                                                    <div className="panel-body">
                                                        <div className="details-listing">
                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <DivLayout
                                                                        heading={"Amount Received From Bank"}
                                                                        data={
                                                                            val?.loan_amount_received_from_bank
                                                                        }
                                                                    />
                                                                </div>
                                                                <div className="col-6">
                                                                    <DivLayout
                                                                        heading={"UTR"}
                                                                        data={
                                                                            val?.bank_transfer_utr_number
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })

                                }
                            </>
                        }

                        {stage === 2 &&
                            <>
                                <div className="panel-card">
                                    <div className="panel-heading">
                                    Customer Account Details
                                    </div>
                                    <div className="panel-body">
                                        <div className="details-listing">
                                        <div className="row">
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Account No"}
                                                        data={
                                                            loanAccountResponse?.PRIMARY?.account_number
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"IFSC Code"}
                                                        data={
                                                            loanAccountResponse?.PRIMARY?.ifsc_code
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Bank Name"}
                                                        data={
                                                            loanAccountResponse?.PRIMARY?.bank_name
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Branch Name"}
                                                        data={
                                                            loanAccountResponse?.PRIMARY?.branch_name
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="panel-card">
                                    <div className="panel-heading">
                                        Dealer Account Details
                                    </div>
                                    <div className="panel-body">
                                        <div className="details-listing">
                                            <div className="row">
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Account No"}
                                                        data={
                                                            loanAccountResponse?.DEALER?.account_number
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"IFSC Code"}
                                                        data={
                                                            loanAccountResponse?.DEALER?.ifsc_code
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Bank Name"}
                                                        data={
                                                            loanAccountResponse?.DEALER?.bank_name
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Branch Name"}
                                                        data={
                                                            loanAccountResponse?.DEALER?.branch_name
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="panel-card">
                                    <div className="panel-heading">
                                        Co-Applicant Account Details
                                    </div>
                                    <div className="panel-body">
                                        <div className="details-listing">
                                            <div className="row">
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Account No"}
                                                        data={
                                                            loanAccountResponse?.CO_APPLICANT?.account_number
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"IFSC Code"}
                                                        data={
                                                            loanAccountResponse?.CO_APPLICANT?.ifsc_code
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Bank Name"}
                                                        data={
                                                            loanAccountResponse?.CO_APPLICANT?.bank_name
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Branch Name"}
                                                        data={
                                                            loanAccountResponse?.CO_APPLICANT?.branch_name
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {stage === 3 &&
                            <>
                                {
                                    loanTranchesResponse?.data?.TRANCHES && loanTranchesResponse?.data?.TRANCHES.length > 0 ?
                                        loanTranchesResponse?.data?.TRANCHES.map((val, i) => {
                                            return (
                                                <>
                                                    <div className="panel-card">
                                                        <div className="panel-heading">
                                                            {`Tranche ${i + 1}`}
                                                        </div>
                                                        <div className="panel-body">
                                                            <div className="details-listing">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Amount to be transferred"}
                                                                            data={
                                                                                val?.amount
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Account Number"}
                                                                            data={
                                                                                val?.account_number
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"IFSC Code"}
                                                                            data={
                                                                                val?.ifsc_code
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Bank Name"}
                                                                            data={
                                                                                val?.bank_name
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Branch Name"}
                                                                            data={
                                                                                val?.branch_name
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Mode of Payment"}
                                                                            data={
                                                                                val?.payment_mode
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"UTR Number"}
                                                                            data={
                                                                                val?.utr_number
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Status"}
                                                                            data={
                                                                                val?.status
                                                                            }
                                                                        />
                                                                    </div>
                                                                    {parseInt(roleId) === 13 && val?.status === 'APPROVAL_PENDING' &&
                                                                        <>
                                                                            <div className="col-md-12 d-flex">
                                                                                <div className="col-md-6">
                                                                                    <button
                                                                                        className="btn btn-primary btn-user btn-block submit-btn"
                                                                                        onClick={(e) => {
                                                                                            handleChangeStatus(e, val?.tranche_id, 'APPROVED')
                                                                                        }}
                                                                                    >
                                                                                        Approve
                                                                                    </button>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <button
                                                                                        className="btn btn-primary btn-user btn-block submit-btn"
                                                                                        onClick={(e) => {
                                                                                            handleChangeStatus(e, val?.tranche_id, 'REQUEST_FOR_MODIFICATION')
                                                                                        }}
                                                                                    >
                                                                                        Back To Modification
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        }) : <img src={Images?.NoData} alt="" width="40%"
                                                  style={{position: "relative", left: "10rem"}}/>
                                }
                                {
                                    loanTranchesResponse?.data?.HOLD_BACK_TRANCHE && loanTranchesResponse?.data?.HOLD_BACK_TRANCHE.length > 0 ?
                                        loanTranchesResponse?.data?.HOLD_BACK_TRANCHE.map((val, i) => {
                                            return (
                                                <>
                                                    <div className="panel-card">
                                                        <div className="panel-heading">
                                                            {`Hold Back ${i + 1}`}
                                                        </div>
                                                        <div className="panel-body">
                                                            <div className="details-listing">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Account to be transferred"}
                                                                            data={
                                                                                val?.amount
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Account Number"}
                                                                            data={
                                                                                val?.account_number
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"IFSC Code"}
                                                                            data={
                                                                                val?.ifsc_code
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Bank Name"}
                                                                            data={
                                                                                val?.bank_name
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Branch Name"}
                                                                            data={
                                                                                val?.branch_name
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Mode of Payment"}
                                                                            data={
                                                                                val?.payment_mode
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"UTR Number"}
                                                                            data={
                                                                                val?.utr_number
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Status"}
                                                                            data={
                                                                                val?.status
                                                                            }
                                                                        />
                                                                    </div>
                                                                    {parseInt(roleId) === 13 && (val?.status === 'APPROVAL_PENDING') &&
                                                                        <>
                                                                            <div className="col-md-12 d-flex">
                                                                                <div className="col-md-6">
                                                                                    <button
                                                                                        className="btn btn-primary btn-user btn-block submit-btn"
                                                                                        onClick={(e) => {
                                                                                            handleChangeStatus(e, val?.tranche_id, 'APPROVED')
                                                                                        }}
                                                                                    >
                                                                                        Approve
                                                                                    </button>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <button
                                                                                        className="btn btn-primary btn-user btn-block submit-btn"
                                                                                        onClick={(e) => {
                                                                                            handleChangeStatus(e, val?.tranche_id, 'REQUEST_FOR_MODIFICATION')
                                                                                        }}
                                                                                    >
                                                                                        Back To Modification
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    }

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        }) : <img src={Images?.NoData} alt="" width="40%"
                                                  style={{position: "relative", left: "10rem"}}/>
                                }

                                {
                                    loanTranchesResponse?.data?.FORE_CLOSURE_TRANCHE && loanTranchesResponse?.data?.FORE_CLOSURE_TRANCHE.length > 0 ?
                                        loanTranchesResponse?.data?.FORE_CLOSURE_TRANCHE.map((val, i) => {
                                            return (
                                                <>
                                                    <div className="panel-card">
                                                        <div className="panel-heading">
                                                            {`Fore Closure ${i + 1}`}
                                                        </div>
                                                        <div className="panel-body">
                                                            <div className="details-listing">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Account to be transferred"}
                                                                            data={
                                                                                val?.amount
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Account Number"}
                                                                            data={
                                                                                val?.account_number
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"IFSC Code"}
                                                                            data={
                                                                                val?.ifsc_code
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Bank Name"}
                                                                            data={
                                                                                val?.bank_name
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Branch Name"}
                                                                            data={
                                                                                val?.branch_name
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Mode of Payment"}
                                                                            data={
                                                                                val?.payment_mode
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"UTR Number"}
                                                                            data={
                                                                                val?.utr_number
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <DivLayout
                                                                            heading={"Status"}
                                                                            data={
                                                                                val?.status
                                                                            }
                                                                        />
                                                                    </div>
                                                                    {parseInt(roleId) === 13 && (val?.status === 'APPROVAL_PENDING') &&
                                                                        <>
                                                                            <div className="col-md-12 d-flex">
                                                                                <div className="col-md-6">
                                                                                    <button
                                                                                        className="btn btn-primary btn-user btn-block submit-btn"
                                                                                        onClick={(e) => {
                                                                                            handleChangeStatus(e, val?.tranche_id, 'APPROVED')
                                                                                        }}
                                                                                    >
                                                                                        Approve
                                                                                    </button>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <button
                                                                                        className="btn btn-primary btn-user btn-block submit-btn"
                                                                                        onClick={(e) => {
                                                                                            handleChangeStatus(e, val?.tranche_id, 'REQUEST_FOR_MODIFICATION')
                                                                                        }}
                                                                                    >
                                                                                        Back To Modification
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                    {/* {(parseInt(userId) === 886 || parseInt(userId) === 876) &&
                                                                        parseInt(roleId) === 13 && (val?.status === 'APPROVAL_PENDING') &&
                                                                        <>
                                                                            <div className="col-md-12 d-flex">
                                                                                <div className="col-md-6">
                                                                                    <button
                                                                                        className="btn btn-primary btn-user btn-block submit-btn"
                                                                                        onClick={(e) => {
                                                                                            handleChangeStatus(e, val?.tranche_id, 'APPROVED')
                                                                                        }}
                                                                                    >
                                                                                        Approve
                                                                                    </button>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <button
                                                                                        className="btn btn-primary btn-user btn-block submit-btn"
                                                                                        onClick={(e) => {
                                                                                            handleChangeStatus(e, val?.tranche_id, 'REQUEST_FOR_MODIFICATION')
                                                                                        }}
                                                                                    >
                                                                                        Back To Modification
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    } */}

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        }) : <img src={Images?.NoData} alt="" width="40%"
                                                  style={{position: "relative", left: "10rem"}}/>
                                }
                            </>
                        }

                        {stage === 4 &&
                            <>
                                {
                                    loanTranchesResponse?.data?.TRANCHES && loanTranchesResponse?.data?.TRANCHES.length > 0 ?
                                        loanTranchesResponse?.data?.TRANCHES.map((value, i) => {
                                            return (
                                                <>
                                                    {value?.status &&
                                                        <div className="panel-card">
                                                            <div className="panel-heading">
                                                            {`Tranche ${i + 1}`}
                                                            </div>
                                                            <div className="panel-body">
                                                                <div className="details-listing">
                                                                    <div className="row">
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Account to be transferred"}
                                                                                data={
                                                                                    value?.amount
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Account Number"}
                                                                                data={
                                                                                    value?.account_number
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"IFSC Code"}
                                                                                data={
                                                                                    value?.ifsc_code
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Bank Name"}
                                                                                data={
                                                                                    value?.bank_name
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Branch Name"}
                                                                                data={
                                                                                    value?.branch_name
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Status"}
                                                                                data={
                                                                                    value?.status
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Mode of Payment"}
                                                                                data={
                                                                                    value?.payment_mode
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"UTR Number"}
                                                                                data={
                                                                                    value?.utr_number
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Status"}
                                                                                data={
                                                                                    value?.status
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                        </div>
                                                                        {value?.status !== 'DISBURSED' && parseInt(roleId) === 49 &&
                                                                            <>
                                                                                <div className="col-sm-4">
                                                                                    <DropDownInput
                                                                                        label={'Action'}
                                                                                        data={[{
                                                                                            id: "INITIATED",
                                                                                            name: "INITIATED"
                                                                                        }, {
                                                                                            id: 'DISBURSED',
                                                                                            name: "DISBURSED"
                                                                                        }, {
                                                                                            id: "CANCELLED",
                                                                                            name: "CANCELLED"
                                                                                        }]}
                                                                                        getIdValue={(val) => {
                                                                                            setStatus(val?.id)
                                                                                        }}
                                                                                        isStarRequired={true}
                                                                                        required={true}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-sm-4">
                                                                                    <ConstantInput
                                                                                        label={"UTR Number"}
                                                                                        handleChange={(val) =>
                                                                                            setUtrNo(val)
                                                                                        }

                                                                                        type="text"
                                                                                        required={status === 'DISBURSED'}
                                                                                        isStarRequired={status === 'DISBURSED'}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-sm-4">
                                                                                    <button
                                                                                        className="btn btn-primary btn-user btn-block submit-btn"
                                                                                        onClick={() => {
                                                                                            handleChangeStatusForRelease(value?.tranche_id)
                                                                                        }}>
                                                                                        Submit
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        }

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        }) : <img src={Images?.NoData} alt="" width="40%"
                                                  style={{position: "relative", left: "10rem"}}/>
                                }

                                {
                                    loanTranchesResponse?.data?.HOLD_BACK_TRANCHE && loanTranchesResponse?.data?.HOLD_BACK_TRANCHE.length > 0 ?
                                        loanTranchesResponse?.data?.HOLD_BACK_TRANCHE.map((value, i) => {
                                            return (
                                                <>
                                                    {value?.status &&
                                                        <div className="panel-card">
                                                            <div className="panel-heading">
                                                                {`Hold back ${i + 1}`}
                                                            </div>
                                                            <div className="panel-body">
                                                                <div className="details-listing">
                                                                    <div className="row">
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Account to be transferred"}
                                                                                data={
                                                                                    value?.amount
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Account Number"}
                                                                                data={
                                                                                    value?.account_number
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"IFSC Code"}
                                                                                data={
                                                                                    value?.ifsc_code
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Bank Name"}
                                                                                data={
                                                                                    value?.bank_name
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Branch Name"}
                                                                                data={
                                                                                    value?.branch_name
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Status"}
                                                                                data={
                                                                                    value?.status
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Mode of Payment"}
                                                                                data={
                                                                                    value?.payment_mode
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"UTR Number"}
                                                                                data={
                                                                                    value?.utr_number
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Status"}
                                                                                data={
                                                                                    value?.status
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">

                                                                        </div>
                                                                        {value?.status !== 'DISBURSED' && parseInt(roleId) === 49 &&
                                                                            <>
                                                                                <div className="col-sm-4">
                                                                                    <DropDownInput
                                                                                        label={'Action'}
                                                                                        data={[{
                                                                                            id: "INITIATED",
                                                                                            name: "INITIATED"
                                                                                        }, {
                                                                                            id: 'DISBURSED',
                                                                                            name: "DISBURSED"
                                                                                        }, {
                                                                                            id: "CANCELLED",
                                                                                            name: "CANCELLED"
                                                                                        }]}
                                                                                        getIdValue={(val) => {
                                                                                            setStatus(val?.id)
                                                                                        }}
                                                                                        isStarRequired={true}
                                                                                        required={true}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-sm-4">
                                                                                    <ConstantInput
                                                                                        label={"UTR Number"}
                                                                                        handleChange={(val) =>
                                                                                            setUtrNo(val)
                                                                                        }

                                                                                        type="text"
                                                                                        required={status === 'DISBURSED'}
                                                                                        isStarRequired={status === 'DISBURSED'}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-sm-4">
                                                                                    <button
                                                                                        className="btn btn-primary btn-user btn-block submit-btn"
                                                                                        onClick={() => {
                                                                                            handleChangeStatusForRelease(value?.tranche_id)
                                                                                        }}>
                                                                                        Submit
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        }

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        }) : <img src={Images?.NoData} alt="" width="40%"
                                                  style={{position: "relative", left: "10rem"}}/>
                                }
                                {
                                    loanTranchesResponse?.data?.FORE_CLOSURE_TRANCHE && loanTranchesResponse?.data?.FORE_CLOSURE_TRANCHE.length > 0 ?
                                        loanTranchesResponse?.data?.FORE_CLOSURE_TRANCHE.map((value, i) => {
                                            return (
                                                <>
                                                    {value?.status &&
                                                        <div className="panel-card">
                                                            <div className="panel-heading">
                                                                {`Fore Closure ${i + 1}`}
                                                            </div>
                                                            <div className="panel-body">
                                                                <div className="details-listing">
                                                                    <div className="row">
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Account to be transferred"}
                                                                                data={
                                                                                    value?.amount
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Account Number"}
                                                                                data={
                                                                                    value?.account_number
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"IFSC Code"}
                                                                                data={
                                                                                    value?.ifsc_code
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Bank Name"}
                                                                                data={
                                                                                    value?.bank_name
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Branch Name"}
                                                                                data={
                                                                                    value?.branch_name
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Status"}
                                                                                data={
                                                                                    value?.status
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Mode of Payment"}
                                                                                data={
                                                                                    value?.payment_mode
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"UTR Number"}
                                                                                data={
                                                                                    value?.utr_number
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <DivLayout
                                                                                heading={"Status"}
                                                                                data={
                                                                                    value?.status
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div className="col-6">

                                                                        </div>
                                                                        {value?.status !== 'DISBURSED' && parseInt(roleId) === 49 &&
                                                                            <>
                                                                                <div className="col-sm-4">
                                                                                    <DropDownInput
                                                                                        label={'Action'}
                                                                                        data={[{
                                                                                            id: "INITIATED",
                                                                                            name: "INITIATED"
                                                                                        }, {
                                                                                            id: 'DISBURSED',
                                                                                            name: "DISBURSED"
                                                                                        }, {
                                                                                            id: "CANCELLED",
                                                                                            name: "CANCELLED"
                                                                                        }]}
                                                                                        getIdValue={(val) => {
                                                                                            setStatus(val?.id)
                                                                                        }}
                                                                                        isStarRequired={true}
                                                                                        required={true}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-sm-4">
                                                                                    <ConstantInput
                                                                                        label={"UTR Number"}
                                                                                        handleChange={(val) =>
                                                                                            setUtrNo(val)
                                                                                        }

                                                                                        type="text"
                                                                                        required={status === 'DISBURSED'}
                                                                                        isStarRequired={status === 'DISBURSED'}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-sm-4">
                                                                                    <button
                                                                                        className="btn btn-primary btn-user btn-block submit-btn"
                                                                                        onClick={() => {
                                                                                            handleChangeStatusForRelease(value?.tranche_id)
                                                                                        }}>
                                                                                        Submit
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        }

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        }) : <img src={Images?.NoData} alt="" width="40%"
                                                  style={{position: "relative", left: "10rem"}}/>
                                }


                            </>
                        }
                        {/*{stage === 4 &&*/}
                        {/*    <>*/}
                        {/*        {loanPaymentRequestResponse?.data.length > 0 ?*/}
                        {/*            loanPaymentRequestResponse?.data.map((val, i) => {*/}
                        {/*                return (*/}
                        {/*                    <>*/}
                        {/*                        <div className="panel-card">*/}
                        {/*                            <div className="panel-heading">*/}
                        {/*                                {`Request ${i + 1}`}*/}
                        {/*                            </div>*/}
                        {/*                            <div className="panel-body">*/}
                        {/*                                <div className="details-listing">*/}
                        {/*                                    <div className="row">*/}
                        {/*                                        <div className="col-6">*/}
                        {/*                                            <DivLayout*/}
                        {/*                                                heading={"Account to be transferred"}*/}
                        {/*                                                data={*/}
                        {/*                                                    val?.amount*/}
                        {/*                                                }*/}
                        {/*                                            />*/}
                        {/*                                        </div>*/}
                        {/*                                        <div className="col-6">*/}
                        {/*                                            <DivLayout*/}
                        {/*                                                heading={"Account Number"}*/}
                        {/*                                                data={*/}
                        {/*                                                    val?.acount_number*/}
                        {/*                                                }*/}
                        {/*                                            />*/}
                        {/*                                        </div>*/}
                        {/*                                        <div className="col-6">*/}
                        {/*                                            <DivLayout*/}
                        {/*                                                heading={"IFSC Code"}*/}
                        {/*                                                data={*/}
                        {/*                                                    val?.idfc_code*/}
                        {/*                                                }*/}
                        {/*                                            />*/}
                        {/*                                        </div>*/}
                        {/*                                        <div className="col-6">*/}
                        {/*                                            <DivLayout*/}
                        {/*                                                heading={"Bank Name"}*/}
                        {/*                                                data={*/}
                        {/*                                                    val?.bank_name*/}
                        {/*                                                }*/}
                        {/*                                            />*/}
                        {/*                                        </div>*/}
                        {/*                                        <div className="col-6">*/}
                        {/*                                            <DivLayout*/}
                        {/*                                                heading={"Branch Name"}*/}
                        {/*                                                data={*/}
                        {/*                                                    val?.branch_name*/}
                        {/*                                                }*/}
                        {/*                                            />*/}
                        {/*                                        </div>*/}
                        {/*                                        <div className="col-6">*/}
                        {/*                                            <DivLayout*/}
                        {/*                                                heading={"Mode of Payment"}*/}
                        {/*                                                data={*/}
                        {/*                                                    val?.mode_of_payment*/}
                        {/*                                                }*/}
                        {/*                                            />*/}
                        {/*                                        </div>*/}
                        {/*                                        <div className="col-6">*/}
                        {/*                                            <DivLayout*/}
                        {/*                                                heading={"Status"}*/}
                        {/*                                                data={*/}
                        {/*                                                    val?.status*/}
                        {/*                                                }*/}
                        {/*                                            />*/}
                        {/*                                        </div>*/}

                        {/*                                        {(parseInt(roleId) === 13 || parseInt(roleId) === 49) &&*/}
                        {/*                                            <div className="col-sm-4">*/}
                        {/*                                            <DropDownInput*/}
                        {/*                                                    label={'Action'}*/}
                        {/*                                                    data={[{*/}
                        {/*                                                        id: "initiated",*/}
                        {/*                                                        name: "Initiated"*/}
                        {/*                                                    }, {*/}
                        {/*                                                        id: 'Completed',*/}
                        {/*                                                        name: "Completed"*/}
                        {/*                                                    }, {id: "Cancelled", name: "Cancelled"}]}*/}
                        {/*                                                    getIdValue={(val) => handleChangeStatus('', val.id, 'bank_name', i)}*/}
                        {/*                                                    isStarRequired={true}*/}
                        {/*                                                    required={true}*/}
                        {/*                                                />*/}
                        {/*                                            </div>*/}
                        {/*                                        }*/}

                        {/*                                    </div>*/}
                        {/*                                </div>*/}
                        {/*                            </div>*/}
                        {/*                        </div>*/}
                        {/*                    </>*/}
                        {/*                )*/}
                        {/*            }) :*/}
                        {/*            <img src={Images?.NoData} alt="" width="40%"*/}
                        {/*                 style={{position: "relative", left: "10rem"}}/>*/}
                        {/*        }*/}
                        {/*    </>*/}

                        {/*}*/}
                        <div className="d-flex">
                            {parseInt(stage) > 1 &&
                                <div className="col-md-6">
                                    <button
                                        className="btn btn-primary btn-user btn-block submit-btn"
                                        onClick={() => {
                                            handleStage(stage - 1)
                                        }}>
                                        Go Back
                                    </button>
                                </div>
                            }

                            {parseInt(stage) <= 3 &&
                                <div className="col-md-6">
                                    <button
                                        className="btn btn-primary btn-user btn-block submit-btn"
                                        onClick={() => {
                                            handleStage(stage + 1)
                                        }}>
                                        Next
                                    </button>
                                </div>
                            }

                            {/*{parseInt(stage) === 4 &&*/}
                            {/*    <div className="col-md-6">*/}
                            {/*        <button*/}
                            {/*            className="btn btn-primary btn-user btn-block submit-btn"*/}
                            {/*        >*/}
                            {/*            Submit*/}
                            {/*        </button>*/}
                            {/*    </div>*/}
                            {/*}*/}
                        </div>
                    </form>

                    <ModalPop
                        title={"Change Status"}
                        show={changeCarLoanStatusModalOpen}
                        handleModalHide={() => {
                            setChangeCarLoanStatusModalOpen(false)
                        }}
                    >
                        <Fragment>
                            <FormSection>
                                <div className={s.root}>
                                    <div className={s.root}>
                                        <div>
                                            <div className="col-sm-12 col-ms-12 ">
                                                <DropDownInput
                                                    label={'Status'}
                                                    data={[{
                                                        id: "REQUEST_FOR_PAYMENT_RELEASE_APPROVED",
                                                        name: "Approved"
                                                    }, {
                                                        id: "REQUEST_FOR_PAYMENT_MODIFICATION",
                                                        name: "Back To Payment Modification"
                                                    }]}
                                                    value={""}
                                                    isStarRequired={true}
                                                    getIdValue={(val) => setStatus(val.id)}
                                                    required={true}
                                                />

                                            </div>
                                            <div className="col-sm-12">
                                                <ConstantInput
                                                    label={"Remark"}
                                                    handleChange={(val) =>
                                                        setRemark(val)
                                                    }

                                                    type="text"
                                                    required={true}
                                                    isStarRequired={true}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <button
                                                    className="btn btn-primary btn-user btn-block submit-btn"
                                                    onClick={handlePaymentApproval}
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                            <br/>
                                        </div>
                                    </div>
                                </div>
                            </FormSection>
                        </Fragment>
                    </ModalPop>
                </div>


                {/*<div className="col-md-12 mb-2">*/}
                {/*    <center>*/}
                {/*        <Button onClick={handleSubmit}>*/}
                {/*            Submit*/}
                {/*        </Button>*/}
                {/*    </center>*/}
                {/*</div>*/}
            </Layout>
        </>
    );
};

export default PaymentDetails;
